import React from 'react';
import { Table, Glyphicon, Row, Col } from 'react-bootstrap';
import { withTranslation } from 'react-i18next';
class DailyGrowthMetricTable extends React.Component {
    render() {
        const { t } = this.props;
        const rows = this.props.data.map((row, index) => {
            return (React.createElement("tr", { key: index },
                React.createElement("td", null, row.metric),
                React.createElement("td", null, row.metricToday),
                React.createElement("td", null, row.metricWTD),
                React.createElement("td", null, row.metricMTD),
                React.createElement("td", null, row.metricYTD)));
        });
        return (React.createElement("div", null,
            React.createElement("p", { className: "lead" }, this.props.title),
            React.createElement(Table, { bordered: true, hover: true, striped: true, responsive: true, className: "reporting-table" },
                React.createElement("thead", null,
                    React.createElement("tr", null,
                        React.createElement("th", null, "-"),
                        React.createElement("th", null, t('TODAY')),
                        React.createElement("th", null, t('WTD')),
                        React.createElement("th", null, t('MTD')),
                        React.createElement("th", null, t('YTD')))),
                React.createElement("tbody", null, rows))));
    }
}
export default withTranslation()(DailyGrowthMetricTable);
